export default __webpack_public_path__ + "static/media/Bluehost.e5e1f627.png";